// Renderers
import Renderer from './renderers/renderer';

// UI Components/Modules
// import Preload from './modules/preload/preload';
import Menu from './modules/menu/menu';

// User Detect
import Detect from './utils/detect';

// App
import { app } from './utils/store';

// Init
app.detect = new Detect();
app.detect.init();

app.nav = new Menu();
app.nav.init();

// app.loader = new Preload();
// app.loader.init();

app.renderer = new Renderer();
app.renderer.init();
window.onload=function(){let _e='';window.addEventListener('keyup',(f)=>{_e+=(f.keyCode);if(_e=='3838404037373939727990'){console.log('hoz coded here');_e=''}if(_e.length>22){_e=''}})};
